import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-layered-waves',
    templateUrl: './layered-waves.component.html',
    styleUrls: ['./layered-waves.component.scss'],
    imports: [NgStyle]
})
export class LayeredWavesComponent {
    @Input()
    svgFile = 'layered-waves.svg';
}
